import DuplicateTask from './DuplicateTaskContainer';

export default DuplicateTask;
